import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export const AdminLogin = () => {
  const { isAuthenticated, login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (isAuthenticated) return <Navigate to="/admin" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(username, password);
      toast.success("Berhasil masuk.");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Username atau password salah.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center px-6">
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-sm rounded-3xl bg-cream p-8 md:p-10 shadow-2xl"
      >
        <div className="flex items-center gap-2 mb-1">
          <span className="inline-block h-2.5 w-2.5 rounded-full bg-honey" />
          <span className="font-display text-2xl text-ink">Samsi Madu</span>
        </div>
        <p className="text-stone2 text-sm mb-8">Masuk ke panel admin</p>

        <div className="space-y-4">
          <div>
            <Label htmlFor="username" className="text-ink mb-2 block">Username</Label>
            <Input
              id="username"
              data-testid="admin-login-username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus
              className="bg-white border-border/70 focus-visible:ring-honey h-11"
            />
          </div>
          <div>
            <Label htmlFor="password" className="text-ink mb-2 block">Password</Label>
            <Input
              id="password"
              data-testid="admin-login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="bg-white border-border/70 focus-visible:ring-honey h-11"
            />
          </div>
        </div>

        <Button
          type="submit"
          data-testid="admin-login-submit"
          disabled={loading}
          className="mt-8 w-full h-11 rounded-full bg-honey hover:bg-honey-dark text-cream font-semibold"
        >
          {loading ? "Memproses..." : "Masuk"}
        </Button>
      </form>
    </div>
  );
};
